export const UPDATE_MODERATOR_DETAILS_REQUESTED = 'UPDATE_MODERATOR_DETAILS_REQUESTED'
export const UPDATE_MODERATOR_DETAILS_SUCCEEDED = 'UPDATE_MODERATOR_DETAILS_SUCCEEDED'
export const UPDATE_MODERATOR_DETAILS_FAILED = 'UPDATE_MODERATOR_DETAILS_FAILED'
export const FETCH_BUFFER_SUCCEEDED = 'FETCH_BUFFER_SUCCEEDED'